<template>
    <div class="content">
        <div class="page_searcher">
            <CompareSearcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div v-if="modules.length==1">
            <div class="page_block">
                <h3>{{modules[0].chart.title}}
                    <!-- <Mark :id="$route.query.id" style="float:right"/> -->
                </h3>
                <div class="page_block_content">
                    <Chart :datas="datas[0]" :fields="modules[0].fields" :conf="modules[0].chart" :height="400" />
                </div>
            </div>
            <div class="page_block">
                <h3>{{modules[0].name}}
                    <a-button-group style="float:right; margin:0 0 0 10px" >
                        <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1' && mark_permission" :table="isMark(datas[0], modules[0].fields)" :id="$route.query.id" /> -->
                        <a-button @click="lockHeader(0)" :type="locks.indexOf(0)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(0)>=0?'取消固定':'固定表头'}}</a-button>
                        <a-button @click="exportToExcel(modules[0].name)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                        <a-button @click="copy(0)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                    </a-button-group>
                </h3>
                <div class="page_block_content">
                    <DataTable :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" 
                    :data="datas[0]" ref="datatable_0" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[0].xlen"  :show_index="modules[0].show_index"/>
                </div>
            </div>
        </div>
        <div v-if="modules.length>1">
            <div class="page_block">
                <a-tabs v-model="current">
                    <a-tab-pane :tab="m.name" v-for="(m, index) in modules" :key="index">
                        <div class="page_block_content" v-if="current==index">
                            <h3 v-if="modules[index].no_chart!=true">{{modules[index].chart.title}}<Mark :id="$route.query.id" style="float:right"/></h3>
                            <Chart v-if="modules[index].no_chart!=true" :datas="datas[index]" :fields="modules[index].fields" :conf="modules[index].chart" :height="400" />
                            <a-divider dashed style="margin:20px 0 10px 0" v-if="modules[index].no_chart!=true && modules[index].no_table!=true"/>
                            <h3 v-if="modules[index].no_table!=true">{{modules[index].no_chart==true?' ':modules[index].name}}
                                <a-button-group style="float:right; margin:0 0 0 10px" >
                                    <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1' && mark_permission" :table="isMark(datas[index], modules[index].fields)" :id="$route.query.id" /> -->
                                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?'取消固定':'固定表头'}}</a-button>
                                    <a-button @click="exportToExcel(index)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>下载数据</a-button>
                                    <a-button @click="copy(index)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>复制数据</a-button>
                                </a-button-group>
                            </h3>
                            <DataTable v-if="modules[index].no_table!=true" :liucun="modules[index].liucun" :fields="modules[index].fields" :theads="modules[index].theads" 
                            :datas="datas[index]" :ref="`datatable_${index}`" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[index].xlen"  :show_index="modules[index].show_index"/>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import CompareSearcher from '@/components/common/search/compare_searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import Mark from '@/components/common/chart/mark.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        CompareSearcher,
        DataTable,
        Chart,
        Mark,
    },
    created() {
        this.initData()
    },
    watch: {
        modules(newV) {
            if(newV) {
                this.initData()
            }
        },
    },
    methods: {
        initData() {
            let datas=[]
            for(let i=0; i<this.modules.length; i++) {
                this.modules[i].fields = [{'id':'query_add_series', 'title':'对比'}].concat(this.modules[i].fields)
                datas.push([])
            }
            this.datas = datas
        },
        // 获取页面数据
        getData(params) {
            this.loading = true
            let q1 = this.$service.query(this.queryId, params[0])
            let q2 = this.$service.query(this.queryId, params[1])

            Promise.all([q1, q2]).then((datas) => {
                let combine_datas=[]
                this.modules.forEach((m, m_index)=>{
                    let combine = []
                    if(m.chart&&m.chart.series && m.chart.series.compare!=true) {
                        for(let q_index=0; q_index<2; q_index++) {
                            datas[q_index][m_index].forEach((row)=>{
                                row['query_add_series'] = `对比${q_index==0?'一':'二'}`
                                row[m.chart.series.id]=`对比${q_index==0?'一':'二'}-${row[m.chart.series.id]}`
                                combine.push(row)
                            })
                        }
                    } 
                    else {
                        if(m.chart) {
                            if(m.chart.type=='mixin') {
                                m.chart.compare=true
                            }
                            m.chart.series={id:'query_add_series', compare:true}
                            for(let q_index=0; q_index<2; q_index++) {
                                datas[q_index][m_index].forEach((row)=>{
                                    row['query_add_series'] = `对比${q_index==0?'一':'二'}`
                                    combine.push(row)
                                })
                            }
                        }
                    }
                    if(m.chart && m.chart.x) {
                        combine = _.sortBy(combine, m.chart.x.id); 
                    }
                    combine_datas.push(combine)
                })
                this.datas = combine_datas
                this.loading = false
            }).catch((errors)=>{
                this.loading = false
            })
        },
    },
    data() {
        return {
            loading: false,
            locks:[],
            datas:[[]],
            current:0,
        }
    },
}
</script>

<style lang="less" scoped>
.content {
}
.page_error {
    height:300px;
    text-align: center;
}
.page_header {
    background: #fff;
    .page_breadcrumb {
        padding: 20px 30px 0 30px;
    }
    h2 {
        padding: 0 30px;
        margin:20px 0 10px 0;
        font-weight: bold;
    }
    .page_desc {
        padding: 0 30px;
        font-size: 14px;
        color: #bbb;
    }
}
.page_block {
    margin:20px 0;
    background: #fff;
    h3 {
        padding: 10px 20px;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
        line-height: 32px;
    }
    .ant-tabs {
        padding: 0 20px;
    }
    .page_block_content {
        margin:20px 30px;
        min-height: 200px;
        h3 {
            padding: 0px 0 10px 0;
            border-bottom: 0;
            font-weight: bold;
        }
    }
}
</style>